import React, { useContext } from 'react';
import { AgendaContext } from '../../contexts/AgendaContext';
// Mui components
import { Box } from '@mui/material';
// Components
import PaginaPreLoginError from './paginPreLoginError';
import PaginaPreLoginBienvenida from './PaginaPreLoginBienvenida';
// Images
import LogoOsde from '../../utils/images/osde-logo-azul.jpg';
import doctorPreLogin from '../../utils/images/doctor-pre-login.png';

export default function PaginaPreLogin() {
  const { errorAuthPrestador } = useContext(AgendaContext);

  return (
    <Box sx={{ display: 'flex', width: '100%', height: '100vh' }}>
      <Box
        sx={{
          display: 'flex',
          width: '40vw',
          height: '100vh',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
        <Box
          sx={{
            display: 'flex',
            width: '65%',
            maxWidth: '400px',
            height: '80%',
            flexDirection: 'column',
            gap: '3vh'
          }}>
          <img style={{ width: '5.25rem' }} src={LogoOsde} loading="lazy" />
          {!errorAuthPrestador ? (
            <PaginaPreLoginBienvenida />
          ) : (
            <PaginaPreLoginError message={errorAuthPrestador.message} />
          )}
        </Box>
      </Box>
      <Box sx={{ display: 'flex', width: '60vw', height: '100vh', overflow: 'hidden' }}>
        <img src={doctorPreLogin} loading="lazy" />
      </Box>
    </Box>
  );
}
